import DemoRenderer__LegacyDemoInstructions from '@runtime/DemoRenderer';
import InterfaceRenderer__LinkInstructions from '@runtime/TypescriptMetadataRenderer/interface';
import DemoRenderer__LinkInstructions from '@runtime/DemoRenderer';
import legacyImportDemo_3255646695 from "../../../../../packages/component/src/components/time-picker/demo/demo1.js?loadDemo";
import legacyImportDemo_977366372 from "../../../../../packages/component/src/components/time-picker/demo/demo2.js?loadDemo";
import legacyImportDemo_3999791077 from "../../../../../packages/component/src/components/time-picker/demo/demo3.js?loadDemo";
import legacyImportDemo_3784110946 from "../../../../../packages/component/src/components/time-picker/demo/demo4.js?loadDemo";
import legacyImportDemo_1373826019 from "../../../../../packages/component/src/components/time-picker/demo/demo5.js?loadDemo";
import legacyImportDemo_356879712 from "../../../../../packages/component/src/components/time-picker/demo/demo6.js?loadDemo";
import legacyImportDemo_2830472161 from "../../../../../packages/component/src/components/time-picker/demo/demo7.js?loadDemo";
import legacyImportDemo_2193263470 from "../../../../../packages/component/src/components/time-picker/demo/demo8.js?loadDemo";
import * as React from 'react';
export default {
  DemoRenderer__LegacyDemoInstructions,
  InterfaceRenderer__LinkInstructions,
  DemoRenderer__LinkInstructions,
  legacyImportDemo_3255646695,
  legacyImportDemo_977366372,
  legacyImportDemo_3999791077,
  legacyImportDemo_3784110946,
  legacyImportDemo_1373826019,
  legacyImportDemo_356879712,
  legacyImportDemo_2830472161,
  legacyImportDemo_2193263470,
  React
};